import React from "react";
import { Card } from "reactstrap";
import { WidgetsChartsCircle } from "./WidgetsCharts";

const SummaryMapWidget = React.memo(() => {
  // Datos de ejemplo hardcodeados
  const temperatureData = {
    value: 12.5,
    unit: "°C",
    title: "Temperatura",
    difference: "+0.3",
  };
  const salinityData = {
    value: 33.2,
    unit: "psu",
    title: "Salinidad",
    difference: "-0.1",
  };
  const oxygenData = {
    value: 0.75,
    name: "OD%",
    dataColors: ["--vz-success"],
  };

  return (
    <div className="d-flex h-auto gap-2">
      {/* Lado izquierdo - Gráfico de Oxígeno */}
      <div className="flex-fill">
        <Card
          className="h-100 rounded-4"
          style={{ marginBottom: "0rem !important" }}
        >
          <div className="d-flex align-items-center p-2">
            <div className="w-100">
              <WidgetsChartsCircle
                dataColors={oxygenData.dataColors}
                value={oxygenData.value}
                name={oxygenData.name}
              />
            </div>
          </div>
        </Card>
      </div>

      {/* Lado derecho - Temperatura y Salinidad */}
      <div className="flex-fill">
        <div className="d-flex flex-column justify-content-between h-100 gap-2">
          {/* Card de Temperatura */}
          <Card className="flex-fill rounded-4">
            <div className="d-flex justify-content-center align-items-center p-3 h-100">
              <div className="text-center">
                <h3 className="m-0 fw-bold text-primary">
                  {temperatureData.value} {temperatureData.unit}
                </h3>
                <h6 className="mb-1 text-muted">{temperatureData.title}</h6>
                <div className="text-muted">
                  <span className="fw-bold fs-13">
                    {temperatureData.difference} {temperatureData.unit}
                  </span>
                  <span className="fst-italic fs-12 ms-1">
                    vs. semana anterior
                  </span>
                </div>
              </div>
            </div>
          </Card>

          {/* Card de Salinidad */}
          <Card className="flex-fill rounded-4">
            <div className="d-flex justify-content-center align-items-center p-3 h-100">
              <div className="text-center">
                <h3 className="m-0 fw-bold text-info">
                  {salinityData.value} {salinityData.unit}
                </h3>
                <h6 className="mb-1 text-muted">{salinityData.title}</h6>
                <div className="text-muted">
                  <span className="fw-bold fs-13">
                    {salinityData.difference} {salinityData.unit}
                  </span>
                  <span className="fst-italic fs-12 ms-1">
                    vs. semana anterior
                  </span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
});

export default SummaryMapWidget;
